import Header from '../header/header';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from '../Container';
import SettingsMenu from '../dashboard/settings/layout/SettingsMenu';
import SettingsSubMenu from '../dashboard/settings/layout/SettingsSubMenu';
import styles from './settingsLayout.module.scss';
import { CommonLayoutProps } from '@/types/other';
import useHeaderQuery from '@/hooks/useHeaderQuery';
import Footer from '../footer';

const SettingsLayout = ({ children, user }: CommonLayoutProps) => {
  const { userQuery } = useHeaderQuery();

  return (
    <div>
      <Header />
      <Container className="tw-h-fit">
        <Row className="g-0">
          <Col lg="auto" className={`d-none d-lg-block ${styles.hideMobile} tw-pb-20`}>
            <SettingsMenu userId={userQuery.data?.id ?? null} />
          </Col>
          <Col lg={2} className={`border-start ${styles.hideMobile} tw-pb-20`}>
            <SettingsSubMenu user={userQuery.data || null} />
          </Col>
          <Col className="tw-pb-20">{children}</Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default SettingsLayout;
